// src/components/ui/EmptyResults.jsx
import React from 'react';

const EmptyResults = ({ resetSearch }) => {
  return (
    <div
      className="flex flex-col items-center text-center bg-gray-100 rounded-3xl px-5 py-10 mb-6 sm:px-8 sm:py-16 border-2 border-dashed border-indigo-200"
      dir="rtl"
    >

      {/* Illustration */}
      <div
        className="mb-5 w-16 h-16 sm:w-24 sm:h-24"
        aria-hidden="true"
        style={{ animation: 'empty-float 3s ease-in-out infinite' }}
      >
        <svg viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-full">
          <circle cx="44" cy="44" r="30" stroke="#c7d2fe" strokeWidth="3" fill="#eef2ff" />
          <line x1="66" y1="66" x2="80" y2="80" stroke="#a5b4fc" strokeWidth="4" strokeLinecap="round" />
          <line x1="34" y1="34" x2="54" y2="54" stroke="#a5b4fc" strokeWidth="3" strokeLinecap="round" />
          <line x1="54" y1="34" x2="34" y2="54" stroke="#a5b4fc" strokeWidth="3" strokeLinecap="round" />
        </svg>
      </div>

      <p className="text-base sm:text-xl font-bold text-indigo-950 tracking-tight mb-2">
        לא נמצאו תוצאות
      </p>

      <p className="text-sm text-gray-400 max-w-[280px] leading-relaxed mb-6">
        נסה לחפש במונח אחר או לשנות את פרמטרי החיפוש
      </p>

      <button
        type="button"
        onClick={resetSearch}
        className="inline-flex items-center min-h-[44px] px-6 py-2.5 bg-gradient-to-br from-indigo-500 to-violet-600 text-white text-sm font-semibold rounded-xl shadow-[0_4px_14px_rgba(99,102,241,0.35)] hover:-translate-y-px hover:shadow-[0_6px_20px_rgba(99,102,241,0.4)] active:translate-y-0 active:shadow-[0_2px_8px_rgba(99,102,241,0.3)] transition-all duration-150 cursor-pointer border-none"
      >
        נקה את החיפוש
      </button>

      {/* keyframe for float animation — unavoidable inline style */}
      <style>{`@keyframes empty-float { 0%,100%{transform:translateY(0)} 50%{transform:translateY(-6px)} }`}</style>
    </div>
  );
};

export default EmptyResults;